import { LAYOUT_TONES, type LayoutTone } from "./layoutCatalog";

export const TONE_TEXT_CLASS: Record<LayoutTone, string> = {
  default: "text-content_primary",
  muted: "text-content_tertiary",
  positive: "text-content_accent1_primary",
  negative: "text-content_accent2_primary",
  warning: "text-content_accent3_primary",
  brand: "text-content_brand_primary",
};

export const LAYOUT_CARD_CLASS =
  "flex w-full flex-col gap-3 rounded-3 border border-border_solid bg-background_solid_primary p-4 md:max-w-[500px]";

export const pickEnum = <T extends string>(
  value: unknown,
  allowed: readonly T[],
  fallback: T,
): T =>
  typeof value === "string" && (allowed as readonly string[]).includes(value)
    ? (value as T)
    : fallback;

export const resolveTone = (value: unknown): LayoutTone =>
  pickEnum(value, LAYOUT_TONES, "default");

/** Trimmed non-empty text, or null when the prop is missing or not text. */
export const resolveText = (value: unknown): string | null => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return String(value);
  }
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};
